import { render, staticRenderFns } from "./NumberExercises.vue?vue&type=template&id=189336b4&scoped=true&"
import script from "./NumberExercises.vue?vue&type=script&lang=js&"
export * from "./NumberExercises.vue?vue&type=script&lang=js&"
import style0 from "./NumberExercises.vue?vue&type=style&index=0&id=189336b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189336b4",
  null
  
)

export default component.exports